import { createSelector } from 'reselect'
import { RootState } from '@store/index'
import * as R from 'ramda'
import { Apartment } from '@models/apartment'

export const selectAllApartments = (state: RootState) => state.timelineState.apartments

const selectTimelineApartments = (state: RootState) => state.timelineState.apartments
export const selectAvailableApartments = createSelector([selectTimelineApartments], apartments =>
  apartments.filter(a => !a.is_virtual && a.available),
)
export const apartmentsSelectSelector = createSelector(selectAllApartments, apartments => {
  const availableApartments = apartments.filter(
    (apartment: Apartment) => !apartment.is_virtual && (apartment.available || apartment.temporary_not_available),
  )

  return R.sortWith<Apartment>([R.ascend(byAccommodationType)])(availableApartments).map(apartment => ({
    value: String(apartment.id),
    label: apartment.name,
  }))
})

const byAccommodationType = (apartment: Apartment) =>
  [1, 4].includes(apartment.accommodation_type) ? 20000 + apartment.position : apartment.position

export const selectIsContextMenuVisible = (state: RootState): boolean => state.timelineState.isContextMenuShowed

export const selectRentSessions = (state: RootState) => state.timelineState.rent_sessions
